import { createFileRoute } from '@tanstack/react-router'

import PagePlaygroundRemoveBackground from '../pages/PagePlaygroundRemoveBackground'

export const Route = createFileRoute('/playground/remove-background')({
  component: PagePlaygroundRemoveBackground
})
